module.exports = __webpack_public_path__ + "media/images/countrysquared/gd-b0e646960df24ba589e415fb62dfdae2.svg";